import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { CaricamentoService, ModoCaricamento } from './caricamento.service';

/**
 * Intestazione di servizio con cui una chiamata dichiara quanto disturbo
 * merita: `silenzioso`, `barra` o `bloccante`. Viene tolta prima di partire,
 * il server non deve vederla.
 */
export const INTESTAZIONE_CARICAMENTO = 'X-Caricamento';

/**
 * Senza indicazioni: leggere mostra la barra, scrivere blocca la pagina.
 *
 * Il blocco sulle scritture non e' estetica: finche' le schermate non
 * disabilitano i propri pulsanti durante il salvataggio, e' quello che evita
 * il doppio invio.
 *
 * L'eccezione non e' un dettaglio: `NgxCrudService.search()` manda le ricerche
 * in **POST** su `.../search`. Guardando solo il verbo, il velo finirebbe
 * addosso a ogni caricamento di elenco e a ogni autocomplete — cioe' proprio
 * il fastidio che stiamo togliendo. Una ricerca e' una lettura, comunque la si
 * spedisca.
 */
function modoPredefinito(richiesta: HttpRequest<unknown>): ModoCaricamento {
  if (richiesta.method.toUpperCase() === 'GET') return 'barra';

  const percorso = richiesta.url.split('?')[0].replace(/\/+$/, '');
  if (percorso.endsWith('/search')) return 'barra';

  return 'bloccante';
}

function modoRichiesto(richiesta: HttpRequest<unknown>): ModoCaricamento | null {
  const valore = richiesta.headers.get(INTESTAZIONE_CARICAMENTO);
  return valore === 'silenzioso' || valore === 'barra' || valore === 'bloccante' ? valore : null;
}

export const caricamentoInterceptor: HttpInterceptorFn = (
  richiesta: HttpRequest<unknown>,
  avanti: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const caricamento = inject(CaricamentoService);

  const modo = modoRichiesto(richiesta) ?? modoPredefinito(richiesta);
  const daInviare = richiesta.headers.has(INTESTAZIONE_CARICAMENTO)
    ? richiesta.clone({ headers: richiesta.headers.delete(INTESTAZIONE_CARICAMENTO) })
    : richiesta;

  const attesa = caricamento.apri(modo);

  // `finalize` copre risposta, errore e annullamento, e soprattutto lascia
  // passare tutti gli eventi: la versione precedente ri-emetteva solo gli
  // `HttpResponse`, quindi l'avanzamento dei caricamenti non arrivava a nessuno.
  return avanti(daInviare).pipe(finalize(() => caricamento.chiudi(attesa)));
};
